import { render, staticRenderFns } from "./InstanceUsageCard.vue?vue&type=template&id=526afc6b&"
import script from "./InstanceUsageCard.vue?vue&type=script&lang=js&"
export * from "./InstanceUsageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports